import React, { useEffect, useState } from "react";
import {
  Button,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Table,
} from "reactstrap";
import ApiRequest from "../helpers/api_server";
import DropDownAlert from "./DropDownAlert";
import { STATUS_REASONS } from "../constants/status";
import SimpleLoading from "./SimpleLoading";

function ModalDocumentHistory({ resetModal, customerId }) {
  // console.log(customerId)
  const [data, setData] = useState(undefined);

  // get data
  async function getHistoryDocument() {
    try {
      const data = await ApiRequest.get(
        `/customer/validation/history/${customerId}`
      );
      setData(data?.data);
      // resetModal();
    } catch (error) {
      DropDownAlert.show("danger", `[data history]:  ${error}`);
      // resetModal();
    }
  }

  useEffect(() => {
    setTimeout(() => {
      getHistoryDocument();
    }, 1200);
  }, []);

  return (
    <Modal isOpen={true} size={"xl"}>
      <ModalHeader>History Dokumen</ModalHeader>
      <ModalBody>
        {data && (
          <Table
            className="mt-2 mb-0 table-nowrap text-center"
            responsive
            bordered
          >
            <thead>
              <tr>
                <th>Tanggal Perubahan</th>
                <th>Status</th>
                <th>Tervalidasi</th>
                <th>Validator</th>
              </tr>
            </thead>
            <tbody>
              {data &&
                data?.map((item, index) => {
                  return (
                    <tr key={index} className="text-right">
                      <td className="text-center">{item?.tanggal_perubahan}</td>
                      <td className="text-center">
                        {index === data?.length - 1 &&
                        item?.status_description === ""
                          ? "Upload"
                          : item?.status_description !== ""
                          ? item?.status_description
                          : "Upload Ulang"}
                      </td>
                      <td>
                        {item.status_validasi === STATUS_REASONS.APPROVE && (
                          <div className="d-flex justify-content-center align-items-center">
                            <span>
                              <i
                                className="uil uil-check text-success"
                                style={{ fontSize: 21 }}
                              ></i>
                            </span>
                          </div>
                        )}

                        {item.status_validasi === STATUS_REASONS.REUPLOAD && (
                          <div className="d-flex justify-content-center align-items-center">
                            <span>
                              <i
                                class="uil uil-upload-alt text-primary"
                                style={{ fontSize: 19 }}
                              ></i>
                            </span>
                          </div>
                        )}

                        {![
                          STATUS_REASONS.APPROVE,
                          STATUS_REASONS.REUPLOAD,
                        ].includes(item.status_validasi) && (
                          <div className="d-flex justify-content-center align-items-center">
                            <span>
                              <i
                                class="uil uil-exclamation-triangle text-warning"
                                style={{ fontSize: 19 }}
                              ></i>
                            </span>
                          </div>
                        )}
                      </td>

                      <td className="text-center">{item?.validator}</td>
                    </tr>
                  );
                })}
            </tbody>
          </Table>
        )}

        {data === undefined && <SimpleLoading />}
        {data === null && (
          <h2 className="text-center">Tidak ada data history</h2>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" className="ml-1" onClick={resetModal}>
          Tutup
        </Button>
      </ModalFooter>
    </Modal>
  );
}

export default ModalDocumentHistory;
